import { PermissionEnum } from '@Application/Security/Roles';
import useDocumentRoute from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Hooks/useDocumentRoute';
import useSubjectModifiability from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Hooks/useSubjectModifiability';
import useHasPermission from '@UI/Providers/PermissionProvider/useHasPermission';
import { useSelector } from '@verclam/synapse';

/**
 * The single place that decides whether this screen's fields accept a correction: a loaded document and
 * a dossier that accepts writes (an unknown dossier counts as not editable) — for a beneficiary, also
 * the beneficiary write permission. `FieldCard`, `FieldOptionToggles`, and `SourcePanelSidebar`
 * all read this instead of each re-deriving the same condition on their own. The dossier is fetched by
 * `DocumentDetailsContent`, which mounts none of them before it has arrived.
 */
const useCanEditDocument = (): boolean => {
	const document = useSelector((state) => state.documentsStore.document);
	const { subject } = useDocumentRoute();
	const { canModify } = useSubjectModifiability(subject);
	const hasBeneficiaryWrite = useHasPermission(PermissionEnum.SUBJECT_WRITE);

	return document !== null && canModify && (!subject.isBeneficiary || hasBeneficiaryWrite);
};

export default useCanEditDocument;
